/**
 * To use this function, you can protect the words with square brackets
 * in order to keep them as is.
 *
 * Example:
 * formatSingularOrPlural(1, 'trou [de trop]'); // "1 trou de trop"
 * formatSingularOrPlural(2, 'trou [de trop]'); // "2 trous de trop"
 * formatSingularOrPlural(3, 'trou [si] large'); // "3 trous si larges"
 */
export const formatSingularOrPlural = (
  count: number,
  words: string,
  options = { isValueVisible: true },
) => {
  const wordsList = splitPattern(words.trim())
    .filter(Boolean)
    .map((word) => word.trim());

  const labelsList = wordsList.map((section) => {
    if (isNotToBePluralized(section)) {
      return cleanBrackets(section);
    }

    return addPlural(section, count);
  });

  const label = labelsList.join(" ");
  if (!options.isValueVisible) {
    return label;
  }

  return `${count} ${label}`;
};

function splitPattern(str: string) {
  const initialSplit = str.split(/(\[[^\]]+\])/);

  return initialSplit
    .flatMap((part: string) => {
      if (part.startsWith("[") && part.endsWith("]")) {
        return part.trim();
      } else {
        return part.trim().split(/\s+/);
      }
    })
    .filter(Boolean);
}

function addPlural(word: string, count: number) {
  return `${word}${count > 1 ? "s" : ""}`;
}

function isNotToBePluralized(word: string) {
  const regex = new RegExp("\\[[^\\]]*\\]", "i");
  return regex.test(word);
}

function cleanBrackets(str: string) {
  return str.replace(/^\[|\]$/g, "");
}
